
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatInputModule, MatAutocompleteModule, MatSlideToggleModule, MatIconModule, MatButtonModule, MatDialogModule, MatSnackBarModule, MatRadioModule,
         MatDatepickerModule, MatNativeDateModule, MatSelectModule, MatFormFieldModule } from '@angular/material';

import { SidebarService } from './sidebar.service';
import { SidebarComponent } from './sidebar.component';

@NgModule({
    imports: [
    	BrowserModule, FormsModule, ReactiveFormsModule, BrowserAnimationsModule, CommonModule, BrowserModule, HttpModule,
        MatInputModule, MatAutocompleteModule, MatSlideToggleModule, MatIconModule, MatButtonModule, MatDialogModule,
        MatSnackBarModule, MatRadioModule,
        MatDatepickerModule, MatNativeDateModule, MatSelectModule, MatFormFieldModule
    ],
    entryComponents: [],
    exports: [SidebarComponent],
    declarations: [
        SidebarComponent
    ],
    providers: [SidebarService],
    bootstrap: []
})

export class SidebarModule {}
